import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import Divider from "@mui/material/Divider"
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from "@mui/material/IconButton"
import dynamic from "next/dynamic"
import Image from "next/image";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useSelector } from "react-redux";
import { getSetting, isDefined } from "../../config/helpers";
import useWindowSize from "../../_hooks/useWindowSize";
const PageHead = dynamic(() => import("../Reusables/PageHead"));
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const AboutUsSchema = dynamic(() => import("../Schemas/AboutUsSchema"));
const HomeStatistics = dynamic(() => import("../HomeComponent/HomeStatistics"));
const ParseHtml = dynamic(() => import("../../Custom/ParseHtml"));


const AboutUs = (props) => {

    /**
     * Side menu with related pages (careers, faq etc.)
     * TODO: https://www.diy.com/corporate/about
     */

    const {
        template_page_settings,
        qt_scores,
        customer_score,
    } = props;
    
    const { template_settings, agent, template_page_content } = useSelector((state) => state.globalReducer);
    const { isMobile } = agent;
    const screensize = useWindowSize();

    const page_content = template_page_content['aboutus']

    const spacing = screensize.width < 1200 || (!isDefined(screensize.width) && isMobile) ? 5 : 5;
    const gridPadding = {
        paddingLeft: {
            xs: 0,
            lg: 0
        },
        paddingRight: {
            xs: 0,
            lg: 0
        }
    }

    const layout = getSetting(
        template_settings,
        template_page_settings,
        "layout",
        "wide"
    );

    const gridToMapOver = [
        'section_7', 'section_8', 'section_9', 'section_10', 'section_11', 'section_12', 'section_13'
    ]
    

    const reasonArr = [
        {
            title: 'All prices are published on the website - Transparent from the outset',
        },
        {
            title: 'Obtain instant online quotations - No need to wait for your costs',
        },
        {
            title: 'Fixed delivery and collection charges',
        },
        {
            title: 'Huge stocks available - All stock is our own',
        },
        {
            title: 'Live customer service score displayed on website',
        },
        {
            title: 'Nationwide delivery - Depots in London & Manchester',
        },
        {
            title: 'Order 24/7 - Fully e-commerce for added flexibility',
        },
        {
            title: 'Price match promise - We guarantee to match or beat any other furniture hire quote',
        },
    ]
    
    return (
        <>
        <PageHead
            title={template_page_content['aboutus'].meta.meta_title}
            description={template_page_content['aboutus'].meta.meta_description}
        />
        <AboutUsSchema />
        {/* <div>{parseHTML(html)}</div> */}
        <BoxContainer className="mt-2 mb-6" template_page_settings={template_page_settings}>
            {page_content.page_title ? (
                <>
                    <Typography className="mt-2 mb-4">{page_content.page_title.content}</Typography>
                    <Divider className="mb-3"/>
                </>
                
                ) : (
                <Typography className="text-center f-size_5 mb-5" component="h1" variant="h1">{`About ${process.env.brand.brand_name}`}</Typography>
            )}

            {/* section 1 */}
            <Grid
                sx={gridPadding}
                className="mb-3" spacing={spacing} container>
                {page_content.section_1_image && <Grid item xs={12} lg={6}>
                    <Box className="position-relative h-100">
                        <Image
                            src={'/about-us-img.jpg'}
                            alt={`About ${process.env.brand.brand_name}`}
                            fill
                            sizes="700px"
                            priority={true}
                            style={{
                                objectFit: 'cover'
                            }}
                        />
                    </Box>
                </Grid>}
                
                <Grid item xs={12} lg={page_content.section_1_image ? 6 : 12}>
                {page_content.section_1 && !page_content.page_title && (
                    <>
                        <ParseHtml html={page_content.section_1.title}/>
                        <ParseHtml html={page_content.section_1.content}/>
                    </>
                )}
                </Grid>
            </Grid>

            <Grid
                sx={gridPadding}
                className="mb-3" spacing={spacing} container>

            {/* Customer Service Section */}

            

                {page_content.section_qt_scores && (
                    <>
                    <Grid item xs={12} lg={6}>
                        <Typography className="text-center f-size_5 mb-3" component="h3" variant="h1">Why People Choose Us</Typography>
                        <Typography className="text-center f-size_2 mb-3">Here's why we think you should work with us</Typography>
                        <ul>
                            {reasonArr.map((element, idx) => (
                                <li className="mb-2 d-flex" key={idx}>
                                    <IconButton aria-label={element.slug} size="small">
                                        <CheckCircleOutlineIcon fontSize="small" />
                                    </IconButton>
                                    {element.title}
                                </li>
                            ))}
                        </ul>
                    </Grid>

                    <Grid item xs={12} lg={6}>
                        <Typography className="text-center f-size_5 mb-3" component="h3" variant="h1">Customer Service Level</Typography>
                        <Typography className="text-center f-size_2">Our customer satisfaction level over the past 30 days: {customer_score}%</Typography>

                        <ul>
                            {Object.keys(qt_scores).map((qt, idx) => (
                                <li className="mb-1 p-2" key={idx}>
                                    <Typography className="f-size_4">
                                        {`${qt_scores[qt].title} ${qt_scores[qt].score}%`}
                                    </Typography>
                                    <LinearProgress value={qt_scores[qt].score} variant="determinate" color={qt_scores[qt].colour} />
                                </li>
                            ))}
                        </ul>
                    </Grid>
                    </>
                )}

            {/* Philosophy & Mission */}

            {page_content.section_3 && (
                <Grid item xs={12} lg={6}>
                    <ParseHtml html={page_content.section_3.content}/>
                    {page_content.section_3_image && <Box sx={{
                        height: '100px'
                    }} 
                        className="position-relative mt-4"
                    >
                        <Image
                            src={page_content.section_3_image.content}
                            alt={`About ${process.env.brand.brand_name}`}
                            fill
                            sizes="700px"
                        />
                    </Box>}
                </Grid>
            )}

            {page_content.section_4 && (
                <Grid item xs={12} lg={6}>
                    <ParseHtml html={page_content.section_4.content}/>
                    {page_content.section_4_images && (
                        <Grid spacing={5} className="h-100" container>
                            <Grid item xs={4}>
                                <Box sx={{
                                    height: '161px'
                                }} 
                                className="position-relative mt-4">
                                    <Image
                                        src={'/Award_2011SLBA.png'}
                                        alt={`About ${process.env.brand.brand_name}`}
                                        fill
                                        sizes="200px"

                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box sx={{
                                    height: '161px'
                                }} 
                                className="position-relative mt-4">
                                    <Image
                                        src={'/Award_2015HAE.png'}
                                        alt={`About ${process.env.brand.brand_name}`}
                                        fill
                                        sizes="200px"

                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box sx={{
                                    height: '161px'
                                }} 
                                className="position-relative mt-4">
                                    <Image
                                        src={'/price_match_logo.png'}
                                        alt={`About ${process.env.brand.brand_name}`}
                                        fill
                                        sizes="200px"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            )}



            </Grid>


            <Grid spacing={spacing} container>
                { 
                    gridToMapOver.map(el => page_content[el] && (
                        <Grid key={el} xs={12} lg={6} item>
                            <ParseHtml html={page_content[el].content}/>
                        </Grid>
                    ) )
                }
            </Grid>

        </BoxContainer>

        {(page_content.section_5) && <Box>
            {(page_content.section_5) && screensize.width < 1200 || (!isDefined(screensize.width) && isMobile) ? <HomeStatistics type="mobile"/> : <HomeStatistics layout={layout} screensize={screensize} isMobile={isMobile} type="desktop" />}
        </Box>}

        {page_content.section_6 && <BoxContainer className="mt-4 mb-3" template_page_settings={template_page_settings}>
            <ParseHtml html={page_content.section_4.content}/>
        </BoxContainer>}
        </>
    
    )
}

export default AboutUs